import { FeatureFlagConfig } from './types'

export const featureFlagConfig: FeatureFlagConfig[] = [
  {
    name: 'bdp_list_cro_test',
    splitTest: '10_2023_Web_BDP_List_CRO_Test',
    source: 'server',
    enabled: true,
  },
  {
    name: 'chat',
    source: 'client',
    enabled: false,
  },
  {
    name: 'chatBot',
    source: 'server',
    enabled: true,
    access: 'staging',
  },
  {
    name: 'vertExp',
    source: 'client',
    enabled: true,
    access: 'open',
  },
  {
    name: 'wvDemo',
    source: 'client',
    enabled: true,
  },
  {
    name: 'referralInviteV2',
    source: 'server',
    enabled: true,
  },
  {
    name: 'scoutCKG',
    source: 'server',
    enabled: true,
  },
  {
    name: 'shelfie_v197',
    source: 'server',
    enabled: true,
  },
  {
    name: 'web_signup_remove_book_upsell',
    source: 'server',
    enabled: true,
    splitTest: '09_2025_Web_Signup_Remove_Book_Upsell',
  },
  {
    name: 'web_signup_club_detail_simplified',
    source: 'server',
    enabled: true,
    splitTest: '09_2025_Web_Signup_Club_Detail_Simplified',
  },
  {
    name: 'web_signup_cta_color_test',
    source: 'server',
    enabled: true,
    splitTest: '09_2025_Web_Signup_CTA_Color_Test',
  },
]
